<template>
    <main class="page-main">
        <div class="block">
            <div class="container">

                <div class="col-sm-3" v-if="isSearchableByFields">
                    <ul class="nav nav-pills nav-stacked category-list">
                        <li class="width-p-100" v-for="(field, key) in searchByFields" :key="key" :class="{'active': field.active}">
                            <a style="cursor: pointer" @click="setField(field)"> By {{ field.label }}</a>
                        </li>
                    </ul>
                </div>

                <div :class="{'col-sm-12': !isSearchableByFields, 'col-sm-9': isSearchableByFields}">
                    <div v-if="isSearchableByInput">
                        <input class="exp-search-input" style="padding: 25px"
                            v-model="searchVal"
                            placeholder="Search here ..."
                            type="search"
                            autocomplete="off" @keyup.enter="search">
                    </div>

                    <div class="form-card">
                        <Loading :is-loading="loading"></Loading>
                        <h3> &nbsp;</h3>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th scope="col"># </th>
                                    <template v-for="(tableField, fieldIndex) in tableFields">
                                        <th
                                            :key="fieldIndex"
                                            :style="tableField.style"
                                            :class="tableField.class">
                                                <b v-if="tableField.isBold">{{ tableField.label }}</b>
                                                <span v-else>{{ tableField.label }}</span>
                                        </th>
                                    </template>
                                    <th scope="col">&nbsp;</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(data, key) in searchData">
                                        <tr :key="key">
                                            <td>{{ key }}</td>
                                            <template v-for="(tableField, fieldIndex) in tableFields">
                                                <td
                                                    :key="fieldIndex"
                                                    :style="tableField.style"
                                                    :class="tableField.class">
                                                        <span v-if="tableField.isBold">
                                                            <b v-html="handleNotation(tableField.name, data)"></b>
                                                        </span>
                                                        <span v-else v-html="handleNotation(tableField.name, data)"></span>
                                                        <slot v-if="tableField.slot" :name="tableField.slot" v-bind:data="data"></slot>
                                                </td>
                                            </template>
                                            <td><slot name="options" v-bind:data="data"></slot></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
</template>

<script>
import axios from 'axios'
import Loading from '../../mixins/components/Loading'

export default {
    components: {
        Loading
    },
    props: {
        route: {
            type: String,
            default: null
        },
        isSearchableByFields: {
            type: Boolean,
            default: true
        },
        isSearchableByInput: {
            type: Boolean,
            default: true
        },
        searchByFields: {
            type: [Object, Array],
            default () {
                return []
            }
        },
        tableFields: {
            type: [Object, Array],
            default () {
                return []
            }
        },
        defaultSearchField: {
            type: String,
            default: null
        },
        customSearchData: {
            type: [Object, Array],
            default () {
                return []
            }
        }
    },
    data () {
        return {
            loading: false,
            searchVal: null,
            searchField: this.defaultSearchField,
            searchData: this.customSearchData,
            modal: false
        }
    },
    mounted () {
        this.$emit('onSearch', this)
    },
    methods: {

        setField (field) {
            this.searchField = field.name
            this.searchByFields.filter(fl => {
                fl.active = false
            })
            field.active = true
        },

        handleNotation (field, data) {
            let parts = field.split('.')
            parts.shift()

            if (parts.length >= 1) {
                for (let i in parts) {
                    if (parts.hasOwnProperty(i)) {
                        if (data[parts[i]] !== 'undefined')
                            data = data[parts[i]]
                    }
                }
                return data
            }
        },

        search (customKey, customVal = false) {
            let val
            if (val = customVal ? customVal : this.searchVal) {
                if (val.length >= 3) {
                    this.loading = true
                    this.api().get(this.route + (typeof customKey === "string" ? customKey : this.searchField) + '/' + val)
                        .then(({data}) => {
                            this.loading = false
                            if (typeof data.response === 'object') {
                                this.searchData = data.response
                            }
                        }).catch((error) => {
                            console.log(error)
                        })
                }
            }
        },

        openModal () {
            this.modal = true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/mixins/components/SearchComponent.vue